module.exports = __webpack_public_path__ + "insa-report/web/locale/en-GB/viewer.properties";


//////////////////
// WEBPACK FOOTER
// ./app/insa-report/web/locale/en-GB/viewer.properties
// module id = 963
// module chunks = 3